import type { UserContextApi } from '@/types/api/user-context';

/**
 * Mock user context data for demo mode
 */
export const mockUserContext: UserContextApi = {
  evoOrganisationId: 'org-001',
  userId: 'user-001',
  email: 'sarah.johnson@company.com',
  firstName: 'Sarah',
  lastName: 'Johnson',
  evoSubscriptionId: 'sub-001',
  companyId: null,
  organisationId: null,
  internalUserId: null,
  companies: [
    {
      id: 1,
      name: 'Acme Corporation',
      currencyCode: 'GBP',
      isMultiCompanyGroup: true,
      linkedDatabaseName: null,
      linkedProductName: 'Financials',
    },
    {
      id: 2,
      name: 'TechStart Inc.',
      currencyCode: 'USD',
      isMultiCompanyGroup: false,
      linkedDatabaseName: null,
      linkedProductName: 'Financials',
    },
    {
      id: 3,
      name: 'Global Solutions Ltd.',
      currencyCode: 'EUR',
      isMultiCompanyGroup: true,
      linkedDatabaseName: null,
      linkedProductName: 'DimensionsvNext',
    },
    {
      id: 4,
      name: 'Innovation Partners',
      currencyCode: 'GBP',
      isMultiCompanyGroup: false,
      linkedDatabaseName: null,
      linkedProductName: null,
    },
    {
      id: 5,
      name: 'Enterprise Systems',
      currencyCode: 'GBP',
      isMultiCompanyGroup: false,
      linkedDatabaseName: null,
      linkedProductName: null,
    },
  ],
  createdAt: '2023-01-10T08:00:00Z',
  role: 'Administrator',
  evoOrganisationName: 'Demo Organisation',
};
